import type { SVGProps } from 'react';

export default function CibNvidia(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M11.932 11.729V9.822q.281-.018.563-.02c5.229-.167 8.656 4.495 8.656 4.495s-3.697 5.135-7.667 5.135a5 5 0 0 1-1.541-.244v-5.797c2.036.249 2.448 1.145 3.661 3.183l2.719-2.287s-1.984-2.604-5.333-2.604a9 9 0 0 0-1.057.047zm0-6.313v2.849l.563-.031c7.265-.251 12.016 5.959 12.016 5.959s-5.443 6.619-11.109 6.619c-.489 0-.975-.047-1.459-.129v1.765c.401.047.812.083 1.213.083c5.276 0 9.095-2.697 12.792-5.88c.609.495 3.12 1.688 3.64 2.204c-3.509 2.948-11.697 5.312-16.337 5.312a12 12 0 0 1-1.297-.068v2.485h20.047V5.416zm0 13.772v1.505c-4.88-.871-6.235-5.948-6.235-5.948s2.344-2.589 6.235-3.016v1.651h-.011c-2.041-.249-3.64 1.661-3.64 1.661s.907 3.213 3.651 4.147m-8.656-4.657s2.885-4.26 8.667-4.708V8.266C5.536 8.787 0 14.203 0 14.203s3.136 9.068 11.932 9.896v-1.651c-6.453-.803-8.656-7.917-8.656-7.917"
      ></path>
    </svg>
  );
}
